import React from "react";

function Disclaimer() {
  return (
    <div className="px-4 text-gray-400 font-semibold">
      <p style={{
    fontSize: "7px",
    lineHeight: "9px",
  }}>
        <strong className=" text-gray-500">Disclaimer:</strong> This document is prepared based on the data
        submitted by member institutions of CRIF High Mark Credit Information
        Services Private Limited (CRIF High Mark) and by using the proprietary
        match logic of CRIF High Mark. No alterations are made to the data
        submitted by member institutions and the same is up to date as well as
        accurate to the best of its knowledge. By using data contained in this
        document, the user acknowledges that CRIF High Mark is not responsible
        for errors/omissions resulting from submission of erroneous data from
        Members to CRIF High Mark. This document may not be used or disclosed to
        others, except with the written permission of CRIF High Mark. Any paper
        copy of this document will be considered uncontrolled. If you are not
        the intended recipient, you are not authorized to read, print, retain,
        copy, disseminate, distribute or use this information or any part
        thereof. PERFORM score provided in this document is joint work of CRIF
        SPA (Italy) and CRIF High Mark (India). For any assistance on this
        report, reach out to us at: customerservice@crifhighmark.com
      </p>

      <div  style={{
    fontSize: "7px",
    lineHeight: "9px",
  }} className="grid grid-cols-3 pt-2 ">
        <p>© Copyright 2025. All rights reserved</p>
        <p>CRIF High Mark Credit Information Services Pvt. Ltd</p>
        <p>Confidential</p>
      </div>
    </div>
  );
}

export default Disclaimer;



const appendixData = [
  { sourceIndicator: "SHG", kindOfBusiness: "SHG" },
  { sourceIndicator: "TSR", kindOfBusiness: "TRUST" },
  { sourceIndicator: "NBF", kindOfBusiness: "NBFC" },
  { sourceIndicator: "MFI", kindOfBusiness: "NGO-MFI" },
  { sourceIndicator: "MFI", kindOfBusiness: "NBFC-MFI" },
  { sourceIndicator: "PRB", kindOfBusiness: "PRIVATE BANK" },
  { sourceIndicator: "FRB", kindOfBusiness: "FOREIGN BANK" },
  { sourceIndicator: "SBR", kindOfBusiness: "STOCK BROKER" },
  { sourceIndicator: "COP", kindOfBusiness: "CO-OPERATIVE BANK" },
  { sourceIndicator: "NAB", kindOfBusiness: "NATIONALIZED BANK" },
  { sourceIndicator: "NAB", kindOfBusiness: "SBI AND ASSOCIATES" },
  { sourceIndicator: "INS", kindOfBusiness: "INSURANCE COMPANY" },
  { sourceIndicator: "TEL", kindOfBusiness: "TELECOM COMPANY" },
  { sourceIndicator: "TRD", kindOfBusiness: "TRADING MEMBER" },
  { sourceIndicator: "CCC", kindOfBusiness: "CREDIT CARD COMPANY" },
  { sourceIndicator: "CRA", kindOfBusiness: "CREDIT RATING AGENCY" },
  { sourceIndicator: "HFC", kindOfBusiness: "HOUSING FINANCE COMPANY" },
  { sourceIndicator: "SFC", kindOfBusiness: "STATE FINANCIAL CORPORATION" },
  { sourceIndicator: "CCC", kindOfBusiness: "CREDIT CARD COMPANY" },
  { sourceIndicator: "RRB", kindOfBusiness: "REGIONAL RURAL BANK" },
  { sourceIndicator: "ARC", kindOfBusiness: "Asset Reconstruction Company" },
  { sourceIndicator: "OFI", kindOfBusiness: "Other Financial Institutions" },
  { sourceIndicator: "NHB", kindOfBusiness: "National Housing Bank" },
  { sourceIndicator: "DTC", kindOfBusiness: "DIRECT TO CONSUMER" },
  { sourceIndicator: "SFB", kindOfBusiness: "Small Finance Bank" },
  {
    sourceIndicator: "P2P",
    kindOfBusiness: "Non-Banking Financial Company-Peer-2-Peer Lending",
  },
  { sourceIndicator: "PMB", kindOfBusiness: "Payments Bank" },
  { sourceIndicator: "SUU", kindOfBusiness: "Specified User" },
];



export function AppendixTable() {
  return (
    <div className=" border-gray-500">
            <div className="bg-blue-300 text-black px-2 py-1 mt-6 font-bold">
        <h2 className="font-bold text-lg">Appendix</h2>
      </div>

      <table className="w-full ">
        <thead 
                style={{fontSize: "10px"}}

        >
          <tr className="bg-gray-100">
            <th className="border border-gray-500 px-2 py-1 text-left">
              Source Indicator
            </th>
            <th className="border border-gray-500 px-2 py-1 text-left">
              Kind of Business
            </th>
          </tr>
        </thead>

        <tbody
        style={{fontSize: "8px"}}
        >
          {appendixData.map((item, index) => (
            <tr key={index}>
              <td className="border border-gray-500 px-2 py-1">
                {item.sourceIndicator}
              </td>
              <td className="border border-gray-500 px-2 py-1">
                {item.kindOfBusiness}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}


